import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';

import { resolveScopedStyles } from 'core/utils/styled-jsx';
import { puidsPropTypes } from 'core/utils/prop-types/ads';

import withPuids from 'core/hocs/withPuids';

/**
 * Cтили для контейнера рекламы создаем через `scope`
 * чтоб `styled-jsx` не выставлял классы на amp-ad, что приводит к ошибке
 * валидации амп.
 */
const scoped = resolveScopedStyles((
  <scope>
    <style jsx>{`
      .banner
        display flex
        justify-items center
        margin-bottom 20px
    `}</style>
  </scope>
));

function Ad(props) {
  const {
    autoPad,
    blockId,
    json,
    puids,
  } = props;

  const isAdOk = autoPad && blockId;

  if (!isAdOk) return null;

  const params = {
    ...json,
    ...puids,
  };

  return (
    <div className={scoped.wrapClassNames('banner')}>
      <Helmet>
        <script
          async='async'
          custom-element='amp-ad'
          src='https://cdn.ampproject.org/v0/amp-ad-0.1.js'
        />
      </Helmet>
      <amp-ad
        layout='flex-item'
        width='300'
        height='250'
        type='capirs'
        data-begun-auto-pad={autoPad}
        data-begun-block-id={blockId}
        data-override-width='1000'
        data-override-height='1000'
        data-custom-css='div[id^=begun_block] iframe{margin:0 auto;}'
        data-loading-strategy='0'
        json={JSON.stringify({ params })}
      >
        <div placeholder='' />
        <div fallback='' />
        <scoped.styles />
      </amp-ad>
    </div>
  );
}

Ad.propTypes = {
  name: PropTypes.string,
  autoPad: PropTypes.string.isRequired,
  blockId: PropTypes.string.isRequired,
  json: PropTypes.shape({
    p1: PropTypes.string,
    p2: PropTypes.string,
    pct: PropTypes.string,
  }),
  puids: puidsPropTypes,
};

export default withPuids(Ad);
